import { createContext, useCallback, useContext, useMemo, useState } from "react"

type AuthModalContextValue = {
  isOpen: boolean
  openAuth: () => void
  closeAuth: () => void
}

const AuthModalContext = createContext<AuthModalContextValue>({
  isOpen: false,
  openAuth: () => {},
  closeAuth: () => {},
})

export function AuthModalProvider({ children }: { children: React.ReactNode }) {
  const [isOpen, setIsOpen] = useState(false)
  const openAuth = useCallback(() => setIsOpen(true), [])
  const closeAuth = useCallback(() => setIsOpen(false), [])
  const value = useMemo(
    () => ({
      isOpen,
      openAuth,
      closeAuth,
    }),
    [isOpen, openAuth, closeAuth],
  )

  return <AuthModalContext.Provider value={value}>{children}</AuthModalContext.Provider>
}

export function useAuthModal() {
  return useContext(AuthModalContext)
}
